export default function Approach() {
  const steps = [
    {
      number: '01',
      title: 'Discovery & Alignment',
      description: 'We assess your operations, constraints, and goals to identify where intelligence delivers real value.',
      icon: 'ri-search-eye-line',
      image: 'https://public.readdy.ai/ai/img_res/1c2536a3359ccea4603a202e49da029d.jpg'
    },
    {
      number: '02',
      title: 'System Design',
      description: 'We architect solutions that fit your existing structure—clean, secure, and intentional.',
      icon: 'ri-draft-line',
      image: 'https://readdy.ai/api/search-image?query=Technical%20system%20architecture%20design%20and%20planning%20with%20blueprints%20and%20digital%20interfaces%2C%20professional%20software%20engineers%20designing%20secure%20AI%20solutions%2C%20modern%20workspace%20with%20clean%20structured%20diagrams%20and%20workflow%20charts%2C%20sophisticated%20technology%20planning%20with%20attention%20to%20security%20and%20integration&width=500&height=350&seq=approach-design&orientation=landscape'
    },
    {
      number: '03',
      title: 'Deployment & Integration',
      description: 'AI systems are implemented with minimal disruption and full transparency.',
      icon: 'ri-rocket-line',
      image: 'https://readdy.ai/api/search-image?query=Seamless%20technology%20deployment%20and%20system%20integration%20in%20professional%20business%20environment%2C%20IT%20team%20implementing%20AI%20solutions%20with%20minimal%20disruption%2C%20modern%20corporate%20office%20with%20smooth%20technology%20rollout%2C%20transparent%20implementation%20process%20with%20clear%20communication%20and%20support&width=500&height=350&seq=approach-deployment&orientation=landscape'
    },
    {
      number: '04',
      title: 'Ongoing Optimization',
      description: 'We monitor, refine, and evolve systems as your business grows.',
      icon: 'ri-loop-right-line',
      image: 'https://readdy.ai/api/search-image?query=Continuous%20improvement%20and%20system%20optimization%20with%20performance%20monitoring%20dashboards%2C%20professional%20team%20analyzing%20metrics%20and%20refining%20AI%20workflows%2C%20modern%20business%20intelligence%20environment%20with%20growth%20charts%20and%20optimization%20data%2C%20sophisticated%20ongoing%20support%20with%20clear%20performance%20tracking&width=500&height=350&seq=approach-optimization&orientation=landscape'
    }
  ];

  return (
    <section id="approach" className="bg-[#0F1B2D] py-32">
      <div className="max-w-[1200px] mx-auto px-20">
        <div className="text-center mb-20">
          <span className="text-xs font-semibold text-gray-400 uppercase tracking-[0.15em] mb-4 block">Our Approach</span>
          <h2 className="text-5xl font-bold text-white" style={{ fontFamily: 'Crimson Pro, serif' }}>
            How GenieAiX works
          </h2>
        </div>

        <div className="relative">
          <div className="absolute left-1/2 top-0 bottom-0 w-px bg-white/20 -translate-x-1/2"></div>

          <div className="space-y-24">
            {steps.map((step, index) => (
              <div key={index} className="relative flex items-center">
                <div className="absolute left-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-[#2B6FED] border-4 border-[#0F1B2D] z-10"></div>
                
                <div className="ml-auto w-[600px] pl-16">
                  <div className="bg-[#1A2838] rounded-2xl overflow-hidden relative">
                    <div className="relative h-[240px]">
                      <img 
                        src={step.image}
                        alt={step.title}
                        className="w-full h-full object-cover object-top"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-[#1A2838] to-transparent"></div>
                    </div>
                    <div className="p-10 relative">
                      <div className="absolute top-[-30px] left-8 text-8xl font-bold text-white/10" style={{ fontFamily: 'Crimson Pro, serif' }}>
                        {step.number}
                      </div>
                      <div className="relative">
                        <div className="flex items-start justify-between mb-4">
                          <h3 className="text-2xl font-bold text-white">{step.title}</h3>
                          <div className="w-10 h-10 flex items-center justify-center">
                            <i className={`${step.icon} text-white/40 text-2xl`}></i>
                          </div>
                        </div>
                        <p className="text-base text-gray-300 leading-relaxed">{step.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
